import AppMaquinaCitas from "./../../projects/maquina-de-citas/src";
import AppPaginaTributo from "../../projects/pagina-tributo/src";
import AppEditorMarkdown from "../../projects/editor-markdown/src";
import AppDocumentacionTecnica from "../../projects/documentacion-tecnica/src";
import AppDestinoProductos from "../../projects/destino-de-productos/src";
import AppCajaDeRitmos from "../../projects/caja-de-ritmos/src";
import AppCalculadoraJS from "../../projects/calculadora-de-javascript/src";
// import AppGlobe from "../../projects/globe/src";
import AppChoroplethMap from "../../projects/choropleth-map-d3js/src";
import AppScatterplotGraph from "../../projects/scatterplot-graph";
import AppTreemapDiagram from "../../projects/treemap-diagram-d3js";
import { AppToDoListJuanGp } from '../../projects/to-do-list-juangp';

const appsComponentsAll = {
  AppMaquinaCitas: <AppMaquinaCitas />,
  AppPaginaTributo: <AppPaginaTributo />,
  AppEditorMarkdown: <AppEditorMarkdown />,
  AppDocumentacionTecnica: <AppDocumentacionTecnica />,
  AppDestinoProductos: <AppDestinoProductos />,
  AppCajaDeRitmos: <AppCajaDeRitmos />,
  AppCalculadoraJS: <AppCalculadoraJS />,
  // AppGlobe: <AppGlobe />,
  AppChoroplethMap: <AppChoroplethMap />,
  AppScatterplotGraph: <AppScatterplotGraph />,
  AppTreemapDiagram: <AppTreemapDiagram />,
  AppToDoList: <AppToDoListJuanGp />,
}

export default appsComponentsAll;